import React, { useState } from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import accountService from "../../services/account/account.service";
import { useAuth } from "../../utils/auth";
import { SendEmailChangeEmailDto } from "../../services/account/account.dto";
import { useToast } from "../../utils/toast";
import FormikValueIsValid from "../../utils/FormikValueIsValid";

const ChangeEmailPage = () => {
  const [checked, setChecked] = useState(false);
  const { t } = useTranslation();
  const auth = useAuth();
  const toast = useToast();

  const navigate = useNavigate();
  const containerClassName = classNames(
    "surface-ground flex align-items-center justify-content-center overflow-hidden"
  );

  const formik = useFormik<SendEmailChangeEmailDto>({
    initialValues: {
      newEmail: ""
    },
    enableReinitialize: true,
    validate: (data) => {
      const errors: any = {};

      if (data.newEmail === undefined || data.newEmail === "") {
        errors.newEmail = t("EmailIsRequired");
      }

      return errors;
    },
    onSubmit: (values) => {
      accountService.SendEmailChangeEmail(values).then((res) => {
        if (res) {
          toast.show(t("EmailChangeMessage"), "success");
          navigate("/", { replace: true });
        }
      });
    }
  });

  return (
    <form className={containerClassName} onSubmit={formik.handleSubmit}>
      <div className="flex flex-column align-items-center justify-content-center p-3">
        <div
          className="surface-card border-1 surface-border border-round-2xl shadow-3 p-4 sm:p-5 md:p-6 w-full"
          style={{ maxWidth: "460px" }}
        >
          <div className="text-center mb-5">
            <img src="/images/logoosbuk.png" alt="OSBÜK Logo" height="48" className="mb-3" />
            <div className="text-900 text-2xl sm:text-3xl font-bold mb-2">{t("EmailChange")}</div>
            <span className="text-600 text-sm">Yeni e-posta adresinizi giriniz</span>
          </div>

          <div>
            <label htmlFor="newEmail" className="block text-900 font-medium mb-2">
              {t("NewEmailAddress")}
            </label>
            <InputText
              id="newEmail"
              type="email"
              placeholder={t("EmailAddress")}
              className={classNames("w-full p-3", {
                "p-invalid": FormikValueIsValid(formik, "newEmail")
              })}
              value={formik.values.newEmail}
              onChange={(e) => formik.setFieldValue("newEmail", e.target.value)}
            />
            {FormikValueIsValid(formik, "newEmail") && (
              <div className="p-error mt-2 text-sm">{formik.errors.newEmail}</div>
            )}

            <div className="w-full mt-4">
              <Button label={t("ChangeEmailAdress")} className="w-full p-3 text-base font-semibold" type="submit" />
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default ChangeEmailPage;
